import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Content } from './styles';

export default function PropertyStatus(props) {
  const [topic, setTopic] = useState('');
  const [reference, setReference] = useState('');
  const [businessId, setBusinessId] = useState(0);
  const [address, setAddress] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (props && props.location && props.location.state) {
      const {
        sAddress,
        sBusinessId,
        sReference,
        sTopic,
        sStatus,
      } = props.location.state;
      setAddress(sAddress);
      setBusinessId(sBusinessId);
      setReference(sReference);
      setTopic(sTopic);
      setStatus(sStatus);
    }
  }, [props]);

  return (
    <Container>
      <div className="header">
        <h1>{topic}</h1>

        <div>
          <span>Ref.: {reference}</span>
          <span>Nº do negócio: {businessId}</span>
          <span>{address}</span>
          <span className="status">Status do imóvel: {status}</span>
        </div>
      </div>

      <Content>
        <div>
          <span>Angariado: </span>
          <text>
            Seu imóvel está disponivel para locação internamente, em breve será
            disponibilizado no Portal Apolar.
          </text>
        </div>
        <div>
          <span>Reangariado: </span>
          <text>
            Seu imóvel está disponivel para locação internamente, em breve será
            disponibilizado no Portal Apolar.
          </text>
        </div>
        <div>
          <span>Disponível: </span>
          <text>
            Seu imóvel está disponivel no Portal Apolar e também em outros
            portais do mercado.
          </text>
        </div>
        <div>
          <span>Chave emprestada: </span>
          <text>
            Neste momento as chaves do seu imóvel foram emprestadas para visita.
          </text>
        </div>
        <div>
          <span>Reservado: </span>
          <text>
            Um cliente se interessou pelo seu imóvel, agora irá passar pelo
            processo de análise cadastral. Vamos torcer!
          </text>
        </div>
        <div>
          <span>Locado: </span>
          <text>Seu imóvel encontra-se alugado.</text>
        </div>
        <div>
          <span>Em processo de rescisão: </span>
          <text>
            Seu inquilino formalizou a intenção de desocupar seu imóvel.
          </text>
        </div>
        <div>
          <span>Desocupado: </span>
          <text>
            Seu imóvel está desocupado, aguardando sua autorização para nova
            locação.
          </text>
        </div>
        <div>
          <span>Suspenso: </span>
          <text>
            Seu imóvel está suspenso em nosso sistema até sua autorização para
            nova locação.
          </text>
        </div>
        <div>
          <span>Em processo de revogação: </span>
          <text>
            Estamos preparando para retirar seu imóvel de nosso sistema de
            administração.
          </text>
        </div>
        <div>
          <span>Revogado (Baixado): </span>
          <text>
            Que pena, seu imóvel não está mais em nossa administração.
          </text>
        </div>
      </Content>
    </Container>
  );
}
PropertyStatus.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};
